var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11912_14383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 25L20 20M23.3333 16.6667L25 15",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.334 9.99986L19.1057 9.10653C20.6687 7.54374 22.7885 6.66586 24.9987 6.66602C27.209 6.66617 29.3287 7.54435 30.8915 9.10736C32.4543 10.6704 33.3322 12.7902 33.332 15.0004C33.3318 17.2107 32.4537 19.3304 30.8907 20.8932L30.0007 21.6665",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5L35 35",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6663 30.0002L21.0046 30.8902C19.4233 32.4538 17.2892 33.3308 15.0654 33.3308C12.8416 33.3308 10.7075 32.4538 9.12625 30.8902C8.34685 30.1195 7.72808 29.2019 7.30577 28.1904C6.88346 27.1789 6.66602 26.0937 6.66602 24.9977C6.66602 23.9016 6.88346 22.8164 7.30577 21.8049C7.72808 20.7935 8.34685 19.8758 9.12625 19.1052L9.99959 18.3335",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11912_14383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLink);
export default __webpack_public_path__ + "static/media/noLink.41dc831d4a9ce1c36f389a16e10cb70c.svg";
export { ForwardRef as ReactComponent };